import { cn } from '@/shared/lib/cn';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

const CIRCLE_RADIUS = 25;
const SPEED = 1.25;

type LoaderProps = {
  size?: number;
  strokeWidth?: number;
  currentColor?: boolean;
} & ComponentPropsWithoutRef<'svg'>;

export const Loader = forwardRef<SVGSVGElement, LoaderProps>(
  (
    { size = 24, strokeWidth = 6, currentColor = false, className, ...props },
    ref
  ) => {
    return (
      <svg
        {...props}
        ref={ref}
        width={size}
        height={size}
        viewBox={`0 0 ${CIRCLE_RADIUS * 2} ${CIRCLE_RADIUS * 2}`}
        className={cn(!currentColor && 'text-primary-text', className)}
      >
        <circle
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          cx={CIRCLE_RADIUS}
          cy={CIRCLE_RADIUS}
          strokeWidth={strokeWidth}
          r={CIRCLE_RADIUS - strokeWidth}
        >
          <animateTransform
            type="rotate"
            attributeType="XML"
            repeatCount="indefinite"
            attributeName="transform"
            dur={`${(SPEED * 4) / 3}s`}
            from={`0 ${CIRCLE_RADIUS} ${CIRCLE_RADIUS}`}
            to={`360 ${CIRCLE_RADIUS} ${CIRCLE_RADIUS}`}
          />
          <animate
            repeatCount="indefinite"
            values="1,200; 89,200; 89 200;"
            attributeName="stroke-dasharray"
            dur={`${SPEED}s`}
          />
          <animate
            values="0;-35;-124;"
            repeatCount="indefinite"
            attributeName="stroke-dashoffset"
            dur={`${SPEED}s`}
          />
        </circle>
      </svg>
    );
  }
);

Loader.displayName = 'UI/Loader';
